import appConstants from '../../../../constants';
import { useL18nContext } from '../../ContextProvider/L18n';
import computeClassName from '../../../../utils/computeClassName';

const constants = Object.freeze({
  CLASSNAME_BASE: 'list-none flex flex-col xs:block py-cc-4.5 bg-cc-secondary font-normal text-cc-secondary-contrast text-cc-body-medium'
});

export default function QuickLinks({ className = ''}) {
  const computedClassName = computeClassName(className, constants.CLASSNAME_BASE);
  const { getTranslationFor } = useL18nContext();
  return (
    <ul className={computedClassName}>
      {
        appConstants.CDC_LINKS.quickLinks.map((link, index) => {
          return (
            <li key={index} className={index === 0 ? "inline-block my-2" : "inline-block my-2 xs:ml-6" } >
              <a className="no-underline hover:underline hover:underline-thin" href={link.url} target={link.target}>{ getTranslationFor(link.l18nLabelKey) }</a>
            </li>
          );
        })
      }
    </ul>
  );
}
